var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectHasActiveDiscountForBuildingId } from "../../../selectors/selectDiscountEvent";
import { selectActiveThemedEventInfo } from "../../../selectors/selectEventInfo";
import { utilButton } from "../../../utils/utilButton";
import { utilNumber } from "../../../utils/utilNumber";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { GridItemContainerDefault } from "../../generic/common/GridItemContainerDefault";
import { GridItemContainerDefaultPremium } from "../../generic/common/GridItemContainerDefaultPremium";
import { IconBuilding } from "../../generic/common/icon-building/IconBuilding";
import { IdIconBuildingContext } from "../../generic/common/icon-building/IdIconBuildingContext";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLocaValueProportional } from "../../generic/text/TextLocaValueProportional";
var GridItemBuildingDOM = /** @class */ (function (_super) {
    __extends(GridItemBuildingDOM, _super);
    function GridItemBuildingDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getItemCountInfo = function () {
            var _a = _this.props.item, maxAmount = _a.maxAmount, _b = _a.existingCount, existingCount = _b === void 0 ? 0 : _b, _c = _a.amount, amount = _c === void 0 ? Long.ZERO : _c;
            return (React.createElement("div", { className: "building-item__text " + IdStyles.TextBoldAccent },
                React.createElement(TextLocaValueProportional, { available: amount.add(existingCount), required: maxAmount })));
        };
        _this.getItemAmountInfo = function () {
            var item = _this.props.item;
            return item.amount ? (React.createElement("div", { className: "building-item__text " + IdStyles.TextBoldAccent }, utilNumber.format(item.amount))) : (undefined);
        };
        return _this;
    }
    GridItemBuildingDOM.prototype.render = function () {
        var _a = this.props, item = _a.item, onClick = _a.onClick, className = _a.className, eventIcon = _a.eventIcon, isDiscountActive = _a.isDiscountActive;
        var itemInfo = item.maxAmount !== 999 ? this.getItemCountInfo() : this.getItemAmountInfo();
        var itemStage = item.stage[(item.stageId || 1) - 1 || 0];
        var level = itemStage.visualLevel || itemStage.level || 1;
        var isBuildingSpecial = item.backgroundColor;
        var GridItemComponent = isBuildingSpecial
            ? GridItemContainerDefaultPremium
            : GridItemContainerDefault;
        var badge = item.badgeName && (React.createElement(Badge, { position: IdBadgePosition.TopRight },
            React.createElement(Icon, { icon: IdIcon.BadgePremiumIcn, styleId: "flex flex--guts " + IdStyles.IconLarge },
                React.createElement(Icon, { icon: item.badgeName, styleId: "building-item-badge-icon " + IdStyles.IconSmall }))));
        var eventBadge = eventIcon && (React.createElement(Badge, { position: IdBadgePosition.GridItemTopLeft },
            React.createElement(Icon, { icon: eventIcon, styleId: IdStyles.IconSmall })));
        var discountBadge = isDiscountActive && (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
            React.createElement(Icon, { icon: IdIcon.PrimeSaleIcn, styleId: "" + IdStyles.IconLarge })));
        return (React.createElement(GridItemComponent, { className: "" + className, onClick: function () { return utilButton.onClickWithSound(onClick); } },
            React.createElement("div", { id: "building_" + item.id, className: "building-item flex flex--guts" },
                React.createElement(IconBuilding, { level: level, buildingName: item.name, context: IdIconBuildingContext.BuildItem }),
                itemInfo,
                badge,
                eventBadge,
                discountBadge)));
    };
    GridItemBuildingDOM.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        if (this.props.className !== nextProps.className) {
            return true;
        }
        return this.props.item.id !== nextProps.item.id;
    };
    return GridItemBuildingDOM;
}(React.Component));
var mapState = function (state, ownProps) {
    var item = ownProps.item;
    var eventIcon;
    var themedEventInfo = selectActiveThemedEventInfo(state);
    if (item.requEventId && themedEventInfo) {
        eventIcon = themedEventInfo.icon;
    }
    return __assign({}, ownProps, { eventIcon: eventIcon, isDiscountActive: selectHasActiveDiscountForBuildingId(state, item.id) });
};
export var GridItemBuilding = connect(mapState)(GridItemBuildingDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/GridItemBuilding.tsx
// module id = 2737
// module chunks = 3